import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=950cbd38"
import script from "./pagination.component.ts?vue&type=script&lang=ts&external"
export * from "./pagination.component.ts?vue&type=script&lang=ts&external"
import style0 from "./pagination.component.vue?vue&type=style&index=0&id=950cbd38&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('950cbd38')) {
      api.createRecord('950cbd38', component.options)
    } else {
      api.reload('950cbd38', component.options)
    }
    module.hot.accept("./pagination.component.vue?vue&type=template&id=950cbd38", function () {
      api.rerender('950cbd38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/pagination/pagination.component.vue"
export default component.exports